import { Button } from 'antd'
import styles from './index.module.less'
import UploadFileModal from './components/UploadFileModal'
import AppTable from '@/components/AppTable'
import axios from 'axios'
import { useSetState } from 'ahooks'

const statusText = {
  1: '解析成功',
  2: '创建工程文件',
  3: '创建工程',
}

const Index= (props:any) =>{
  const [state, setState] = useSetState({
    uploadOpen: false,
    totalCount: 0,
    tableParams: {
      zjProjectid: ''
    }
  })

  const columns = [
    {
      title: '文件名称',
      width: 300,
      dataIndex: 'fileName',
      // className: 'text-center',
    },
    {
      title: '文件id',
      width: 80,
      dataIndex: 'fileId',
      // className: 'text-center',
    },
    {
      title: '中交项目id',
      width: 90,
      dataIndex: 'zjProjectId',
      // className: 'text-center',
    },
    {
      title: '造价工程id',
      width: 80,
      dataIndex: 'projectid',
      // className: 'text-center',
    },
    {
      title: '状态',
      width: 80,
      dataIndex: 'status',
      className: 'text-center',
      render: v => statusText[v]
    },
  ]

  const getFileList = (params: any) => {
    return new Promise<any>((resolve, reject) => {
      axios.get('otherapi/api/file-list', {params: {
        pageNum: params.pageIndex,
        pageSize: params.pageSize,
        // zjProjectid: params.zjProjectid
      }}).then(res => {
        // setState({
        //   totalCount: res?.data?.data?.totalCount || 0
        // })
        if (res?.data?.data) {
          resolve({...res.data.data})
        } else {
          reject({...res?.data})
        }
      })
    })
  }

  const handleUploadModalCancel = () => {
    setState({
      uploadOpen: false
    })
  }

  const handleUploadModalOk = (data) => {
    // getFileList({pageSize: 20, pageIndex: 1})
    setState({
      tableParams: {...state.tableParams}
    })
    handleUploadModalCancel()
  }

  const uploadFile = () => {
    setState({
      uploadOpen: true
    })
  }

  return (
    <div className={styles.container}>
      <div className={styles['file-options']}>
        <Button type='primary' onClick={uploadFile}>上传</Button>
        {/* <Button>删除</Button> */}
      </div>
      <div className={styles['table-title']}>
        <div className={styles['table-left-title']}>全部文件</div>
        {/* <div className={styles['table-right-title']}>已全部加载，共{state.totalCount}个</div> */}
      </div>
      <div>
        <AppTable
          api={getFileList}
          rowKey='id'
          params={state.tableParams}
          columns={columns}
          pageIndex={1}
          pageSize={20}
          tableParams={{
            bordered: true,
            size: 'small',
          }}
        />
      </div>
      <UploadFileModal open={state.uploadOpen} onOk={handleUploadModalOk} onCancel={handleUploadModalCancel} />
    </div>
  )
}

export default Index